export default "https://cdn-static.gokick.com/assets/c3e2404f2f1be1cd3bf75e8d7804f871d91db3b2/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";